import React, { useState, useRef, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import Footer from '../components/Footer';

const resortPhotos = [
  { src: '/FS Pic 1.webp', alt: 'Naples Beach Club 1' },
  { src: '/FS Pic 2.jpeg', alt: 'Naples Beach Club 2' },
  { src: '/FS Pic 3.jpg', alt: 'Naples Beach Club 3' },
  { src: '/FS Pic 4.webp', alt: 'Naples Beach Club 4' },
  { src: '/FS Pic 5.webp', alt: 'Naples Beach Club 5' },
  { src: '/FS Pic 6.webp', alt: 'Naples Beach Club 6' },
  { src: '/FS Pic 7.webp', alt: 'Naples Beach Club 7' },
  { src: '/FS Pic 8.webp', alt: 'Naples Beach Club 8' },
  { src: '/FS Pic 9.jpg', alt: 'Naples Beach Club 9' },
  { src: '/FS Pic 10.webp', alt: 'Naples Beach Club 10' },
];

export default function TravelStay() {
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const scrollRef = useRef(null);

  const closeLightbox = useCallback(() => setLightboxIndex(null), []);

  const goNext = useCallback((e) => {
    e.stopPropagation();
    setLightboxIndex((i) => (i + 1) % resortPhotos.length);
  }, []);

  const goPrev = useCallback((e) => {
    e.stopPropagation();
    setLightboxIndex((i) => (i - 1 + resortPhotos.length) % resortPhotos.length);
  }, []);

  useEffect(() => {
    if (lightboxIndex === null) return;
    const handleKey = (e) => {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') setLightboxIndex((i) => (i + 1) % resortPhotos.length);
      if (e.key === 'ArrowLeft') setLightboxIndex((i) => (i - 1 + resortPhotos.length) % resortPhotos.length);
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [lightboxIndex, closeLightbox]);

  const scrollGallery = (dir) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: dir * 240, behavior: 'smooth' });
    }
  };

  return (
    <div className="site-wrapper">
      {/* Full-page photo + cream veil — same pattern as RSVP page */}
      <div className="rsvp-bg-photo" style={{ backgroundImage: "url('/Naples Beach Club, a Four Seasons Resort-NBC_HeroImage_Beach View.png')" }} />
      <div className="rsvp-bg-overlay" />

      <div className="page-content" style={{ position: 'relative', zIndex: 2 }}>
        <div className="travel-content" style={{ maxWidth: '860px', padding: '40px 40px 80px' }}>
          <h2 style={{
            fontFamily: 'var(--font-script)',
            fontSize: '60px',
            fontWeight: 400,
            color: 'var(--green-dark)',
            textAlign: 'center',
            marginBottom: '8px',
            lineHeight: 1.2,
          }}>Travel &amp; Stay</h2>
          <p style={{ textAlign: 'center', marginBottom: '24px', fontWeight: 600, fontSize: '1rem', color: 'grey', fontFamily: 'var(--font-sans)' }}>
            Where to stay and how to get to Naples.
          </p>

          {/* Section: Hotels */}
          {/* Hotel Card */}
          <div className="travel-hotel-card">
            <div className="hotel-header">
              <div className="hotel-header-left">
                <span>Wedding Venue &amp; Room Block</span>
                <h3>Naples Beach Club, A Four Seasons Resort</h3>
              </div>
            </div>

            <div className="hotel-note" style={{ margin: 0, borderRadius: 0, borderLeft: 'none', borderRight: 'none' }}>
              <span>
                We've reserved a room block at the wedding venue hotel. Shuttle transportation for wedding events will run to and from the Naples Beach Club.
              </span>
            </div>

            <div className="hotel-body">
              <div className="hotel-info-grid">
                <div className="hotel-info-item">
                  <div className="hotel-info-label">Address</div>
                  <div className="hotel-info-value">
                    <a href="https://maps.google.com/?q=801+Gulf+Shore+Blvd+N+Naples+FL+34102" target="_blank" rel="noopener noreferrer">
                      801 Gulf Shore Blvd N<br />Naples, FL 34102
                    </a>
                  </div>
                </div>
                <div className="hotel-info-item">
                  <div className="hotel-info-label">Room Block Dates</div>
                  <div className="hotel-info-value">Wed 10/28 – Sun 11/1</div>
                </div>
                <div className="hotel-info-item">
                  <div className="hotel-info-label">Minimum Stay</div>
                  <div className="hotel-info-value">2 nights</div>
                </div>
                <div className="hotel-info-item">
                  <div className="hotel-info-label">Booking Code</div>
                  <div className="hotel-info-value" style={{ fontWeight: 700, fontSize: '1rem', color: 'var(--green)' }}>
                    261001CCW
                  </div>
                </div>
                <div className="hotel-info-item">
                  <div className="hotel-info-label">Book Online</div>
                  <div className="hotel-info-value">
                    <a href="https://www.fourseasons.com/naplesbeachclub/" target="_blank" rel="noopener noreferrer">
                      fourseasons.com
                    </a>
                  </div>
                </div>
                <div className="hotel-info-item">
                  <div className="hotel-info-label">Phone</div>
                  <div className="hotel-info-value">
                    <a href="tel:+12399447600">(239) 944-7600</a>
                  </div>
                </div>
                <div className="hotel-info-item">
                  <div className="hotel-info-label">Extended Stay</div>
                  <div className="hotel-info-value">
                    <a href="mailto:reservations.naplesbeachclub@fourseasons.com">
                      Email reservations
                    </a>
                  </div>
                </div>
                <div className="hotel-info-item">
                  <div className="hotel-info-label">Reserve By</div>
                  <div className="hotel-info-value" style={{ color: 'var(--gold)', fontWeight: 500 }}>
                    September 1, 2026
                  </div>
                </div>
              </div>

              <div className="hotel-steps">
                <h4>How to Book</h4>
                <ul className="hotel-step-list">
                  <li>
                    <div className="step-num">1</div>
                    <span>Visit <a href="https://www.fourseasons.com/naplesbeachclub/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--green)', textDecoration: 'underline' }}>fourseasons.com/naplesbeachclub</a> or call <a href="tel:+12399447600" style={{ color: 'var(--green)', textDecoration: 'underline' }}>(239) 944-7600</a></span>
                  </li>
                  <li>
                    <div className="step-num">2</div>
                    <span>Enter your preferred dates (within Oct 28 – Nov 1 block)</span>
                  </li>
                  <li>
                    <div className="step-num">3</div>
                    <span>Enter promo code <strong style={{ color: 'var(--green)', fontWeight: 600 }}>261001CCW</strong> in the "Promo Code" field next to your reservation dates</span>
                  </li>
                  <li>
                    <div className="step-num">4</div>
                    <span>To stay beyond Oct 28 – Nov 1, email <a href="mailto:reservations.naplesbeachclub@fourseasons.com" style={{ color: 'var(--green)', textDecoration: 'underline', wordBreak: 'break-all' }}>reservations.naplesbeachclub@fourseasons.com</a></span>
                  </li>
                </ul>
              </div>

              {/* Resort Photo Gallery */}
              <div className="resort-gallery">
                <h4>Resort Photos</h4>
                <div className="resort-gallery-wrapper">
                  <button className="resort-gallery-arrow resort-gallery-arrow--left" onClick={() => scrollGallery(-1)} aria-label="Scroll left">&#8249;</button>
                  <div className="resort-gallery-strip" ref={scrollRef}>
                    {resortPhotos.map((photo, i) => (
                      <button
                        key={i}
                        className="resort-gallery-thumb"
                        onClick={() => setLightboxIndex(i)}
                        aria-label={`View ${photo.alt}`}
                      >
                        <img src={photo.src} alt={photo.alt} loading="lazy" />
                      </button>
                    ))}
                  </div>
                  <button className="resort-gallery-arrow resort-gallery-arrow--right" onClick={() => scrollGallery(1)} aria-label="Scroll right">&#8250;</button>
                </div>
              </div>
            </div>
          </div>

          {/* Lightbox (portalled to body to escape stacking context) */}
          {lightboxIndex !== null && createPortal(
            <div className="resort-lightbox" onClick={closeLightbox}>
              <button className="resort-lightbox-close" onClick={closeLightbox} aria-label="Close">&#10005;</button>
              <button className="resort-lightbox-nav resort-lightbox-nav--prev" onClick={goPrev} aria-label="Previous">&#8249;</button>
              <img
                src={resortPhotos[lightboxIndex].src}
                alt={resortPhotos[lightboxIndex].alt}
                className="resort-lightbox-img"
                onClick={(e) => e.stopPropagation()}
              />
              <button className="resort-lightbox-nav resort-lightbox-nav--next" onClick={goNext} aria-label="Next">&#8250;</button>
              <div className="resort-lightbox-counter">{lightboxIndex + 1} / {resortPhotos.length}</div>
            </div>,
            document.body
          )}

          {/* Other Hotel Options */}
          <h2 className="travel-section-title" style={{ marginTop: 56 }}>Other Hotel Options</h2>
          <p className="travel-section-sub">We don't have a room block at these hotels, but they're great options close to the weekend's events.</p>

          <div className="travel-hotels-grid">
            <div className="travel-hotel-card">
              <h4>Hilton Naples</h4>
              <p className="travel-hotel-address">5111 Tamiami Trl N, Naples, FL 34103</p>
              <p>A well-located hotel on Tamiami Trail, convenient to restaurants and events throughout the weekend.</p>
              <a
                href="https://www.hilton.com/en/hotels/apfnhhf-hilton-naples/"
                target="_blank"
                rel="noopener noreferrer"
                className="travel-hotel-link"
              >
                Book at Hilton.com →
              </a>
            </div>

            <div className="travel-hotel-card">
              <h4>AC Hotel Naples 5th Avenue</h4>
              <p className="travel-hotel-address">455 12th St S, Naples, FL 34102</p>
              <p>Marriott property steps from 5th Avenue's dining and nightlife, and a short drive to the beach.</p>
              <a
                href="https://www.marriott.com/en-us/hotels/rswac-ac-hotel-naples-5th-avenue/overview/"
                target="_blank"
                rel="noopener noreferrer"
                className="travel-hotel-link"
              >
                Book at Marriott.com →
              </a>
            </div>
          </div>

          {/* Getting There */}
          <h2 className="travel-section-title" style={{ marginTop: 56 }}>Getting to Naples</h2>
          <p className="travel-section-sub">Naples is easily accessible by car or plane.</p>

          <div className="travel-tips-grid">
            <div className="travel-tip-card">
              <h4>Southwest Florida Intl (RSW)</h4>
              <p>
                The closest major airport, approximately 40 minutes from Naples.
                Served by most major airlines with direct flights from many US cities.
              </p>
            </div>
<div className="travel-tip-card">
              <h4>Driving</h4>
              <p>
                Naples is about 2 hours from Miami, 3.5 hours from Orlando, and
                2 hours from Tampa. Interstate 75 provides direct access.
              </p>
            </div>

          </div>


        </div>
      </div>
      <Footer />
    </div>
  );
}
